import linkifyStr from "linkify-string";
function Linkify(text) {
  return linkifyStr(text, {
    defaultProtocol: "https",
    target: "_blank",
    className: "external linkified",
    attributes: {
      rel: "nofollow noopener noreferrer"
    }
  });
}
const directive = (el, binding) => {
  var _a;
  if (((_a = binding.value) == null ? void 0 : _a.linkify) === true) {
    el.innerHTML = Linkify(binding.value.text);
  }
};
export {
  directive as default
};
//# sourceMappingURL=Linkify.mjs.map
